import { Box, Button, Copy, H5, Icon, IconWrapper, Optional } from '@honda-canada/design-system-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useCurrentVehicleDealerInventoryStatus } from '../../core/apiHooks/useFetchInventoryStatus';
import { selectCurrentVehicle } from '../../core/reducers/currentVehicle';
import { getGtmTagValue, gtmContactDealer } from '../../utils/gtmEvents';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
import constructFromTemplate from './constructFromTemplate';
import useInventoryLeadUrl from './useInventoryLeadUrl';
import themeStyles from './CtaCard.styles';
import { EqualHeight, EqualHeightElement } from '../../utils/components/EqualHeight';
import { useAppSelector } from '../../core/utils';
import { selectDealer } from '../../core/reducers/dealer';
const Container = themeStyles.apply(Box, 'Container');
const CtaWrapper = themeStyles.apply(Box, 'CtaWrapper');
const TextWrapper = themeStyles.apply(Box, 'TextWrapper');
const StyledButton = themeStyles.apply(Button, 'StyledButton');
const CtaButton = ({ children, ...rest }) => (React.createElement(EqualHeightElement, { name: "cta" },
    React.createElement(StyledButton, { ...rest }, children)));
const CtaCard = ({ fields, rendering }) => {
    var _a, _b, _c, _d;
    const gtmComponentType = getGtmTagValue(rendering === null || rendering === void 0 ? void 0 : rendering.componentName);
    const { t } = useTranslation();
    const { modelKey = '', trimKey } = useSelector(selectCurrentVehicle) || {};
    const { data: inventoryStatus } = useCurrentVehicleDealerInventoryStatus();
    const { dealerName, dealerCode, dealerContact } = useAppSelector(selectDealer);
    const { href: hrefTemplate, linktype: linkType, target } = (fields === null || fields === void 0 ? void 0 : fields.ctaLink.value) || {};
    const href = useInventoryLeadUrl(hrefTemplate, dealerCode);
    const ctaTextTemplate = (_c = (_b = (_a = fields === null || fields === void 0 ? void 0 : fields.ctaLink) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.text) !== null && _c !== void 0 ? _c : '';
    const ctaText = constructFromTemplate(ctaTextTemplate, { dealerName });
    const title = (fields === null || fields === void 0 ? void 0 : fields.title.value) || '';
    const subTitleTemplate = ((_d = fields === null || fields === void 0 ? void 0 : fields.subtitle) === null || _d === void 0 ? void 0 : _d.value) || '';
    const subTitle = constructFromTemplate(subTitleTemplate, { dealerName });
    const ariaLabelText = t('Shared.Common.contactDealerCardAria', { dealerName });
    const onClickHandler = () => {
        gtmContactDealer({
            dealerName,
            ctaType: 'contact dealer',
            linkText: 'contact dealer',
            linkUrl: href,
            componentType: gtmComponentType,
            model: modelKey,
            trim: trimKey,
            bodyStyle: fields.gtmBodyStyle.value,
            availabilityFlag: inventoryStatus,
        });
    };
    return (React.createElement(Container, { "data-testid": "cy-contact-dealer" },
        React.createElement(TextWrapper, null,
            React.createElement(Optional, { when: !!title },
                React.createElement(H5, { "data-testid": "cy-contact-dealer-title" }, title)),
            subTitle ? (React.createElement(Copy, { "data-testid": "cy-dealer-name", size: "regular" }, subTitle)) : null),
        React.createElement(CtaWrapper, null,
            React.createElement(EqualHeight, null,
                React.createElement(Optional, { when: ctaText === null || ctaText === void 0 ? void 0 : ctaText.length },
                    React.createElement(CtaButton, { "data-testid": "cy-contact-dealer-name", styling: "primary", as: RoutableSitecoreLink, onClick: onClickHandler, field: {
                            value: {
                                linktype: linkType,
                                href,
                                target,
                            },
                        }, ariaLabel: ariaLabelText }, ctaText)),
                React.createElement(Optional, { when: dealerContact === null || dealerContact === void 0 ? void 0 : dealerContact.length },
                    React.createElement(CtaButton, { styling: "secondary", "aria-label": dealerContact, "data-testid": "cy-contact-dealer-phone", as: "a", href: `tel:${dealerContact}` },
                        React.createElement(IconWrapper, { size: "iconWrapper.xs" },
                            React.createElement(Icon, { name: "phone", mr: "s", iconColorInherit: "secondary" })),
                        dealerContact))))));
};
export default CtaCard;
